const VALID_ENVIRONMENTS = [
  'development',
  'test',
  'integration',
  'live',
] as const;

export type DeploymentEnvironment = (typeof VALID_ENVIRONMENTS)[number];
// = 'development' | 'test' | 'integration' | 'live'

const env = import.meta.env.DEPLOYMENT_ENVIRONMENT;

if (!VALID_ENVIRONMENTS.includes(env)) {
  throw new Error(
    `Invalid DEPLOYMENT_ENVIRONMENT: "${env}". Must be one of: ${VALID_ENVIRONMENTS.join(
      ', '
    )}`
  );
}

const deploymentEnvironment = env;

export const IS_PRODUCTION = deploymentEnvironment === 'live';
export const IS_DEVELOPMENT = deploymentEnvironment === 'development';
export const IS_TEST = deploymentEnvironment === 'test';
export const IS_INTEGRATION = deploymentEnvironment === 'integration';
